/**
 * This file was automatically generated by toolspec-generator.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSON file,
 * and run toolspec-generator to regenerate this file.
 */
import { Tool } from '@aws-sdk/client-bedrock-runtime'

export const TemplatesSchema: Tool[] = [
  {
    toolSpec: {
      name: 'list_templates',
      description:
        'List every saved template as { path, name }. Templates are reusable React/TSX components stored next to dashboards (separate folder tree on the Templates tab). Use this to discover what already exists before authoring a new dashboard so you can compose existing templates with `<Template path="..." />` instead of duplicating logic.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {},
          required: []
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'get_template',
      description:
        "Return the stored TSX `code` and `default_values` for the template at the given path. Use before editing a template (so you build on existing code) or before composing one (so you know which props the template's component reads from `default_values`). Returns an error if no template exists at that path.",
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            path: {
              type: 'string',
              description:
                'Full slash-separated path of the template to read, e.g. "oee/line-card".'
            }
          },
          required: ['path']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'add_template',
      description:
        'Create a NEW template at the given slash-separated path with the given React/TSX `code` AND a `default_values` JSON object spread into the component as initial props. Fails if a template already exists at that path (use edit_template instead). The code must default-export a React component that destructures the props your `default_values` declares; callers can override any of those props at composition sites via `<Template path="..." theProp={value} />`. Templates may compose other templates — the `<Template />` primitive is in scope without imports.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            path: {
              type: 'string',
              description:
                'Full slash-separated path for the new template, e.g. "oee/line-card". The last segment is the template name; earlier segments become folders.'
            },
            code: {
              type: 'string',
              description:
                'The template TSX source. Must default-export a React component. ONLY the in-scope shadcn components and plain HTML may be used (no other component libraries). Shadcn components + React hooks + the `Template` composition primitive are in scope without imports; import icons from "lucide-react" or "@phosphor-icons/react". The component should destructure the props your `default_values` declares — those values are spread into the component as initial props at every render site.'
            },
            default_values: {
              type: 'object',
              additionalProperties: true,
              description:
                "JSON object whose keys are the prop names the template's component destructures. The sandbox spreads these into the component as `{...default_values, ...callerOverrides}` at render time, so they double as both the standalone-preview values AND the fallback for any prop a composition site does not override."
            }
          },
          required: ['path', 'code', 'default_values']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'edit_template',
      description:
        'Overwrite the EXISTING template at the given path. Replaces both `code` and `default_values` together — include the complete component and the complete defaults object, not a diff. Prefer grep_template with `replacement` for small targeted fixes to the TSX code. Use this full rewrite for larger structural changes or when `default_values` must change. Returns an error if no template exists at that path.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            path: {
              type: 'string',
              description: 'Full slash-separated path of the template to edit.'
            },
            code: {
              type: 'string',
              description:
                'The complete replacement TSX source. Must default-export a React component.'
            },
            default_values: {
              type: 'object',
              additionalProperties: true,
              description:
                'The complete replacement default-values JSON object. Keys must match the props the new `code` destructures.'
            }
          },
          required: ['path', 'code', 'default_values']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'grep_template',
      description:
        'Search the stored TSX `code` of an existing template with a JavaScript regular expression (does not search `default_values`). Without `replacement`, returns each match with its 1-based line number and full line text — that response IS enough context; do NOT call get_template afterwards. With `replacement`, applies a GLOBAL multi-line find/replace to the code and persists every match while leaving `default_values` untouched — preferred over edit_template for small targeted code fixes. Prefer the shortest correct pattern so all intended occurrences update in one call. Fails without writing when `replacement` is set and the pattern is invalid, matches nothing, or leaves the code unchanged. Escape regex metacharacters you mean literally.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            path: {
              type: 'string',
              description:
                'Full slash-separated path of the template to search or patch, e.g. "oee/line-card".'
            },
            pattern: {
              type: 'string',
              description:
                "JavaScript regular-expression source (no surrounding slashes, no inline flag groups). Applied globally and multi-line, so '^' and '$' anchor to line boundaries. Keep it short for label/unit swaps so every occurrence is updated. Escape regex metacharacters when you mean them literally."
            },
            replacement: {
              type: 'string',
              description:
                "Optional. When omitted, the tool only reports matches (grep) — use the returned line_text as context and do not read the whole template. When provided, EVERY match in the template's `code` is replaced and persisted; `default_values` are left unchanged. Standard JavaScript replacement patterns apply: '$1'…'$9' insert capture groups and '$$' inserts a literal '$'. Pass an empty string to delete matches."
            }
          },
          required: ['path', 'pattern']
        }
      }
    }
  }
]

export enum TemplatesToolNames {
  ListTemplates = 'list_templates',
  GetTemplate = 'get_template',
  AddTemplate = 'add_template',
  EditTemplate = 'edit_template',
  GrepTemplate = 'grep_template'
}
